import React from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const PackagesTab = ({ packages, onCreateModal, onEditModal, onDelete }) => (
  <div data-testid="packages-tab">
    <div className="flex justify-between items-center mb-6">
      <p className="text-s-text2">{packages.length} packages</p>
      <Button onClick={() => onCreateModal('package')} className="bg-s-primary hover:bg-s-primary-h text-white" data-testid="add-package-btn">
        <Plus className="w-4 h-4 mr-2" /> Add Package
      </Button>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {packages.map((pkg) => (
        <Card key={pkg.id} className="bg-s-bg2 border-s-border overflow-hidden" data-testid={`package-card-${pkg.id}`}>
          <img src={pkg.image} alt={pkg.title} className="w-full h-40 object-cover" />
          <CardContent className="p-4">
            <Badge className="bg-s-primary/20 text-s-primary mb-2">{pkg.type}</Badge>
            <h3 className="text-s-text font-semibold">{pkg.title}</h3>
            <p className="text-s-text2 text-sm">{pkg.destination}</p>
            <div className="flex gap-2 mt-4">
              <Button size="sm" variant="outline" onClick={() => onEditModal('package', pkg)} className="flex-1 border-s-border text-s-text2" data-testid={`edit-package-${pkg.id}`}>
                <Pencil className="w-4 h-4 mr-1" /> Edit
              </Button>
              <Button size="sm" variant="outline" onClick={() => onDelete('package', pkg.id)} className="border-red-500/50 text-s-primary hover:bg-s-primary/20" data-testid={`delete-package-${pkg.id}`}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default PackagesTab;
